export const removeParentheses = (name: string) => {
  return name?.replace(/\(.*\)/, "").trim();
};
